import React, { useEffect } from "react";
import { observer } from "mobx-react";

import { useAuth } from "./hooks/useAuth";

interface Props
{
  children: React.ReactNode;
  onAuthRequired: () => void;
}
export const SessionChecker: React.FC<Props> = observer(({onAuthRequired, children}) =>
{
  const { authStore } = useAuth();
  useEffect(() =>
  {
    if (!authStore.currentUser)
    {
      onAuthRequired();
    }
  }, [authStore.currentUser, onAuthRequired]);
  return <>{children}</>;
});